import React, { HTMLProps } from 'react'
import { ReactComponent as ChevronFullIcon } from '../assets/icons/chevron.svg'
import { ReactComponent as ChevronDefaultIcon } from '../assets/icons/arrow.svg'
import { ChevronType, Direction } from '../utils/constants'
import { twMerge } from 'tailwind-merge'

interface ChevronProps extends HTMLProps<SVGElement> {
  direction: Direction
  type?: ChevronType
}

const Chevron = ({ direction, className, type = ChevronType.DEFAULT }: ChevronProps) => {
    const getChevronDirection = () => {
        switch (direction) {
        case Direction.DOWN:
            return 'rotate-180'
        case Direction.LEFT:
            return '-rotate-90'
        case Direction.RIGHT:
            return 'rotate-90'
        case Direction.UP:
        default:
            return 'rotate-0'
        }
    }
    const attributes = {
        className: twMerge('ml-2 stroke-inherit', getChevronDirection(), className),
    }
    return type === ChevronType.DEFAULT ? (
        <ChevronDefaultIcon {...attributes} />
    ) : (
        <ChevronFullIcon {...attributes} />
    )
}

export default Chevron
